import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '../csttFacadeApi';

 const getCustomerVehicles = (customerReference: string) : AxiosPromise<Array<string>> => csttFacadeApi.get(`/csttfacade/equipment/v1/customer/${customerReference}/externalEquipmentReferences`);
 const getCustomerVehiclesInfo = (vehiclesReferences: string[]):  AxiosPromise<customerVehiclesInfoResponse> => csttFacadeApi.post(`/csttfacade/equipment/v1/getInBatch`, vehiclesReferences)
 export { getCustomerVehicles, getCustomerVehiclesInfo }